import { Component, OnInit } from '@angular/core';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { COUNTRY_SPECIFIC_DATA } from 'src/app/shared/data/country-specific-data';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../providers/api.service';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { element } from 'protractor';

@Component({
  selector: 'sm-all-countries',
  templateUrl: './all-countries.component.html',
  styleUrls: ['./all-countries.component.scss']
})
export class AllCountriesComponent implements OnInit {
  citySpecificData: any[] = [];
  tableDisplayColumn: ITableColumnHeader[] = [
    {
      columnName: "city",
      columnProperty: "city"
    },
    {
      columnName: "user",
      columnProperty: "UserCount"
    },
    {
      columnName: "business",
      columnProperty: "businessCount"
    }
    
  ];
  private _apiSubscription: Subscription;
  constructor(private _apiService: ApiService) { 
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_CITY_SPECIFIC_DATA_RESULT){
        console.log(resData);

        resData.result.forEach((element:any) => {
          if(element.UserCount == null){
            element.UserCount = '-'
          }
          if(element.businessCount == null){
            element.businessCount = '-'
          }
        });
       
        this.citySpecificData = resData.result ? resData.result : [];
        
            console.log( this.citySpecificData);
        
      }
  
    });
  }

  ngOnInit(): void {
    this._apiService.getCitySpecificData('India')
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }
}
